import { render, staticRenderFns } from "./questionAudit.vue?vue&type=template&id=6e4b6ad2&scoped=true&"
import script from "./questionAudit.vue?vue&type=script&lang=js&"
export * from "./questionAudit.vue?vue&type=script&lang=js&"
import style0 from "./questionAudit.vue?vue&type=style&index=0&id=6e4b6ad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b6ad2",
  null
  
)

export default component.exports